// extracted by mini-css-extract-plugin
export default {"backdrop":"appMenu_backdrop__GWNZt"};